import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
// import LoginForm from "./components/LoginForm";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import HomeRedirect from "./components/HomeRedirect";
import AdminRegisterForm from "./components/AdminRegisterForm";
import SystemAdminRegisterForm from "./components/SystemAdminRegisterForm";
import { Users, Clients, ClientShow, ContractorDocumentEdit, Services } from "./pages";
import Layout from "./components/Layout";
import UserShow from "./pages/UserShow";
import UserEdit from "./pages/UserEdit";
import UserCalendar from "./pages/UserCalendar";
import UserCreate from "./pages/UserCreate";
import UserEmailPreferences from "./pages/UserEmailPreferences";
import ClientCreate from "./pages/ClientCreate";
import ClientEdit from "./pages/ClientEdit";
import TicketCreate from "./pages/TicketCreate";
import Staff from "./pages/Staff";
import Departments from "./pages/Departments";
import DepartmentShow from "./pages/DepartmentShow";
import DepartmentEdit from "./pages/DepartmentEdit";
import DepartmentCreate from "./pages/DepartmentCreate";
import PropertyList from "./pages/PropertyList";
import PropertyCreate from "./pages/PropertyCreate";
import PropertyShow from "./pages/PropertyShow";
import PropertyEdit from "./pages/PropertyEdit";
import BlockShow from "./pages/BlockShow";
import BlockCreate from "./pages/BlockCreate";
import BlockEdit from "./pages/BlockEdit";
import BlockEmailGuardiansCreate from "./pages/BlockEmailGuardiansCreate";
import MonthlyInspectionReportView from "./pages/MonthlyInspectionReportView";
import PropertyProposalSign from "./pages/PropertyProposalSign";
import PropertyLiabilityEdit from "./pages/PropertyLiabilityEdit";
import PropertyPhotos from "./pages/PropertyPhotos";
import PropertyEmailGuardiansCreate from "./pages/PropertyEmailGuardiansCreate";
import PropertyDocumentCreate from "./pages/PropertyDocumentCreate";
import PropertyCertificateCreate from "./pages/PropertyCertificateCreate";
import CertificateDemo from "./pages/CertificateDemo";
import PropertyDocuments from "./pages/PropertyDocuments";
import PropertyDocumentEdit from "./pages/PropertyDocumentEdit";
import ResetPassword from "./pages/ResetPassword";
import {
  ClientTickets,
  TicketShow,
  TicketEdit,
  TicketsCalendar,
} from './pages';
import TicketNoteView from './pages/TicketNoteView';
import TicketNoteEdit from './pages/TicketNoteEdit';
import TicketNoteCreate from './pages/TicketNoteCreate';
import TicketNoteAdd from './pages/TicketNoteAdd';
import TicketsMemberCalendar from './pages/TicketsMemberCalendar';
import GuardianTicketGuard from './components/GuardianTicketGuard';
import PropertyViewingsUserCalendar from './pages/PropertyViewingsUserCalendar';
import Guardians from './pages/Guardians';
import GuardianCreate from './pages/GuardianCreate';
import GuardianCreateLaravel from './pages/GuardianCreateLaravel';
import GuardianShow from './pages/GuardianShow';
import GuardianEdit from './pages/GuardianEdit';
import GuardianEditLaravel from './pages/GuardianEditLaravel';
import GuardianDocumentsManage from './pages/GuardianDocumentsManage';
import PropertyApplicationDeclineDocumentation from './pages/PropertyApplicationDeclineDocumentation';
import GuardianPlacementStep1 from './pages/GuardianPlacementStep1';
import GuardianPlacementStep1B from './pages/GuardianPlacementStep1B';
import GuardianPlacementStep2 from './pages/GuardianPlacementStep2';
import GuardianPlacementStep3 from './pages/GuardianPlacementStep3';
import GuardianDashboard from './pages/GuardianDashboard';
import GuardianEditProfile from './pages/GuardianEditProfile';
import RecommendFriendThanks from './pages/RecommendFriendThanks';
import EmptyPropertyTip from './pages/EmptyPropertyTip';
import SalesWithGuardiansDashboard from './pages/SalesWithGuardiansDashboard';
import GuardianViewings from './pages/GuardianViewings';
import GuardianEmailStatusCreate from './pages/GuardianEmailStatusCreate';
// import Rents from "./pages/Rents";
import Rents from './pages/RentsLaravel';
import RentsAfterDateEnd from './pages/RentsAfterDateEnd';
import RentsNoticeToQuit from './pages/RentsNoticeToQuit';
import RentsNoticeToQuitUploadFile from './pages/RentsNoticeToQuitUploadFile';
// import RoomsCouples from "./pages/RoomsCouples";
import RoomsCouples from './pages/RoomsCouplesLaravel';
import HearAbout from './pages/HearAbout';
import Complaints from './pages/Complaints';
import GuardianQueries from './pages/GuardianQueries';
import GuardianQueryDetail from './pages/GuardianQueryDetail';
import GuardiansAfterDeadline from './pages/GuardiansAfterDeadline';
import RentDatesEdit from './pages/RentDatesEdit';
import RentGuardianOfficerEdit from './pages/RentGuardianOfficerEdit';
import RentChangeRent from './pages/RentChangeRent';
import RentPayments from './pages/RentPayments';
import RoomShow from './pages/RoomShow';
import RoomAssign from './pages/RoomAssign';
import RoomManage from './pages/RoomManage';
import NoticeToQuitCreate from './pages/NoticeToQuitCreate';
import NoticeToQuitEdit from './pages/NoticeToQuitEdit';
import PropertyNoticeToQuitGuardianLetters from './pages/PropertyNoticeToQuitGuardianLetters';
import RoleHierarchyTest from './pages/RoleHierarchyTest';
import RentPaymentsEdit from './pages/RentPaymentsEdit';
import MarketingDashboard from './pages/MarketingDashboard';
import RentResale from './pages/RentResale';
import RentLicencesEdit from './pages/RentLicencesEdit';
import './App.css';
import { ToastContainer } from 'react-toastify';
import PendingSyncBadge from './components/PendingSyncBadge';
import 'react-toastify/dist/ReactToastify.css';
import VacantRooms from './pages/VacantRooms';
import PropertyViewingsIndex from './pages/PropertyViewingsIndex';
import PropertyViewingsCreate from './pages/PropertyViewingsCreate';
import PaymentsIndex from './components/PaymentsIndex';
import PropertyNoticeToQuitIndex from './components/PropertyNoticeToQuitIndex';
import PaymentsWithoutDueDate from './pages/PaymentsWithoutDueDate';
import PaymentEdit from './pages/PaymentEdit';
import PropertyViewingsReport from './components/PropertyViewingsReport';
import PropertiesRoomsSearch from './pages/PropertiesRoomsSearch';
import SpacesAvailable from './pages/SpacesAvailable';
import Inspections from './pages/Inspections';
import BuildingManagerCalendar from './pages/BuildingManagerCalendar';
import EmailReminderCreate from './pages/EmailReminderCreate';
import InspectionTypes from './components/InspectionTypes';
import InspectionTypeCreate from './pages/InspectionTypeCreate';
import InspectionTypeEdit from './pages/InspectionTypeEdit';
import PropertiesMonthlyInspections from './pages/PropertiesMonthlyInspections';
import InspectionRoutes from './pages/InspectionRoutes';
import InspectionRouteEdit from './pages/InspectionRouteEdit';
import InspectionRouteCreate from './pages/InspectionRouteCreate';
import InspectionRouteShow from './pages/InspectionRouteShow';
import InspectionEdit from './pages/InspectionEdit';
import ExpenseAccount from './pages/ExpenseAccount';
import ExpenseAccountCreate from './pages/ExpenseAccountCreate';
import ExpenseAccountEdit from './pages/ExpenseAccountEdit';
import ExpenseAccountPay from './pages/ExpenseAccountPay';
import Expenditures from './pages/Expenditures';
import ExpendituresCategories from './pages/ExpendituresCategories';
import BankAccounts from './pages/BankAccounts';
import BankAccountEdit from './pages/BankAccountEdit';
import BankAccountCreate from './pages/BankAccountCreate';
import PettyCash from './pages/PettyCash';
import PettyCashCreate from './pages/PettyCashCreate';
import PettyCashEdit from './pages/PettyCashEdit';
import PropertyViewingsCalendar from './pages/PropertyViewingsCalendar';
import PropertyViewingsEdit from './pages/PropertyViewingsEdit';
import PropertyProposalCreate from './pages/PropertyProposalCreate';
import PropertyProposalEdit from './pages/PropertyProposalEdit';
import ExpenditureItemEdit from './pages/ExpenditureItemEdit';
import PropertyExpenditures from './pages/PropertyExpenditures';
import PropertyViewingsViewDetails from './pages/PropertyViewingsViewDetails';
import PropertyViewingsAttend from './pages/PropertyViewingsAttend';
import PropertyViewingsCopy from './pages/PropertyViewingsCopy';
import PropertyViewingsKeepInformed from './pages/PropertyViewingsKeepInformed';
import PropertyPayments from './pages/PropertyPayments';
import BuildingSetUps from './pages/BuildingSetUps';
import PropertyViewings from './pages/PropertyViewings';
import PropertyMonthlyInspections from './pages/PropertyMonthlyInspections';
import MonthlyInspectionCreate from './pages/MonthlyInspectionCreate';
import MonthlyInspectionEdit from './pages/MonthlyInspectionEdit';
import MonthlyInspectionRedirect from './pages/MonthlyInspectionRedirect';
import InitialInspectionCreate from './pages/InitialInspectionCreate';
import InitialInspectionEdit from './pages/InitialInspectionEdit';
import SpaceShow from './pages/SpaceShow';
import SpaceKeepMeInformed from './pages/SpaceKeepMeInformed';
import PropertyInspections from './pages/PropertyInspections';
import GuardianPayments from './pages/GuardianPayments';
import GuardianPayment from './pages/GuardianPayment';
import ContractorPliUploadPublic from './pages/ContractorPliUploadPublic';
import PliDashboard from './pages/PliDashboard';
import PliReviewQueue from './pages/PliReviewQueue';
// P2P v1 — supplier bills in Xero not yet recorded in MyGlobe
import XeroBillsQueue from './pages/XeroBillsQueue';
import XeroBillRecord from './pages/XeroBillRecord';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailed from './pages/PaymentFailed';
import PaymentCallback from './pages/PaymentCallback';
import MockPayment from './pages/MockPayment';
import PaymentCreate from './pages/PaymentCreate';
import InspectionsCreate from './pages/InspectionsCreate';
import ExpendituresCreate from './pages/ExpendituresCreate';
import ExpenditureShow from './pages/ExpenditureShow';
import ClientsContacts from './pages/ClientsContacts';
import ClientsEmailAll from './pages/ClientsEmailAll';
import ClientsEmailStatusCreate from './pages/ClientsEmailStatusCreate';
import ClientDocumentCreate from './pages/ClientDocumentCreate';
import ClientDocumentEdit from './pages/ClientDocumentEdit';
import VipClientDashboard from './pages/VipClientDashboard';
import Certificates from './pages/Certificates';
import CertificateReviewQueue from './pages/CertificateReviewQueue';
import CertificateEdit from './pages/CertificateEdit';
import LeadSources from './pages/LeadSources';
import LeadSourceCreate from './pages/LeadSourceCreate';
import LeadSourceEdit from './pages/LeadSourceEdit';
import WebsiteLeads from './pages/WebsiteLeads';
import LifeEnhancingChances from './pages/LifeEnhancingChances';
import MarketSegments from './pages/MarketSegments';
import MarketSegmentCreate from './pages/MarketSegmentCreate';
import MarketSegmentEdit from './pages/MarketSegmentEdit';
import QualityGuardiansPlaced from './pages/QualityGuardiansPlaced';
import QualityGuardiansRegistered from './pages/QualityGuardiansRegistered';
import QualityGuardiansForecasting from './pages/QualityGuardiansForecasting';
import BdmDashboard from './pages/BdmDashboard';
import Settings from './pages/Settings';
import SettingsEmail from './pages/SettingsEmail';
import Roles from './pages/Roles';
import RoleEdit from './pages/RoleEdit';
import CrmPermissions from './pages/CrmPermissions';
import CrmRolesPermissions from './pages/CrmRolesPermissions';
import CrmPermissionCategoryUsers from './pages/CrmPermissionCategoryUsers';
import CrmPermissionView from './pages/CrmPermissionView';
import CrmPermissionEdit from './pages/CrmPermissionEdit';
import CrmPermissionCreate from './pages/CrmPermissionCreate';
import Reports from './pages/Reports';
import AuditLog from './pages/AuditLog';
import Contractors from './pages/Contractors';
import ContractorCreate from './pages/ContractorCreate';
import ContractorEdit from './pages/ContractorEdit';
import ContractorShow from './pages/ContractorShow';
import ContractorDocumentCreate from './pages/ContractorDocumentCreate';
import ContractorContacts from './pages/ContractorContacts';
import ContractorContactCalendar from './pages/ContractorContactCalendar';
import GuardianQueryCreate from './pages/GuardianQueryCreate';
import GuardianEmailPreferences from './pages/GuardianEmailPreferences';
import GuardianPropertySearch from './pages/GuardianPropertySearch';
import GuardianPropertyDetails from './pages/GuardianPropertyDetails';
import EmploymentHistoryEdit from './pages/EmploymentHistoryEdit';
import KeepMeInformed from './pages/KeepMeInformed';
import LicenseAgreement from './pages/LicenseAgreement';
import UsefulInformation from './pages/UsefulInformation';
import CostOfWorks from './pages/CostOfWorks';
import CostOfWorksReports from './pages/CostOfWorksReports';
import PropertyGuardianSolution from './pages/PropertyGuardianSolution';
import LuxuryHouseSitting from './pages/LuxuryHouseSitting';
import SafetyManagement from './pages/SafetyManagement';
import BuildingManagement from './pages/BuildingManagement';
import ImproveYourVoid from './pages/ImproveYourVoid';
import PropertyGuardianInsurance from './pages/PropertyGuardianInsurance';
import VoidIntoProfit from './pages/VoidIntoProfit';
import ProptechSoftwareSolutions from './pages/ProptechSoftwareSolutions';
import Tickets from './pages/Tickets';
import TicketDocumentCreate from "./pages/TicketDocumentCreate";
import TicketDocumentEdit from "./pages/TicketDocumentEdit";
import ForgotPassword from './pages/ForgotPassword';
// import Register from './pages/Register';
import UserRegister from './pages/UserRegister';
import SetPayment from './pages/SetPayment';
import MarkAsPaid from './pages/MarkAsPaid';
import MarkAsPaidPayment from './pages/MarkAsPaidPayment';
import SignAgreement from './pages/SignAgreement';
import StartRent from './pages/StartRent';
import GuardianPlacement from './pages/GuardianPlacement';
import GuardianRetentionResponse from './pages/GuardianRetentionResponse';
import GuardianManagerDashboard from './pages/GuardianManagerDashboard';

// import './assets/laravel-form.css';

const App = () => {
  return (
    <AuthProvider>
      <PendingSyncBadge />
      <ToastContainer
        filter={(toast) => {
          // Filter out mock data warnings
          const message = toast?.props?.children?.toString() || '';
          return !message.toLowerCase().includes('mock data') && 
                 !message.toLowerCase().includes('using mock');
        }}
      />
      <Router>
        <div className="App">
          <Routes>
            {/* <Route path="/login" element={<LoginForm />} /> */}
            <Route path="/login" element={<Login />} />
            <Route
              path="/register-system-admin"
              element={<SystemAdminRegisterForm />}
            />
            <Route
              path="/admin-register"
              element={
                <ProtectedRoute>
                  <AdminRegisterForm />
                </ProtectedRoute>
              }
            />
            {/* React/Node.js routes */}
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            
            {/* Laravel-compatible routes for backward compatibility */}
            <Route path="/password/reset" element={<ForgotPassword />} />
            <Route path="/password/reset/:token" element={<ResetPassword />} />
            
            {/* <Route path="/register" element={<Register />} /> */}
            <Route path="/register" element={<UserRegister />} />
            <Route path="/" element={<HomeRedirect />} />

            {/* Guardian Payment Route - Public route without layout */}
            <Route path="/guardian/pay/:token" element={<GuardianPayment />} />
            <Route path="/guardian/pay/mock-payment" element={<MockPayment />} />

            {/* PLI magic-link upload - Public route without layout */}
            <Route path="/contractors/pli/:token" element={<ContractorPliUploadPublic />} />

            {/* Payment Success/Failed Routes - Public routes for GoCardless/Nuapay callbacks */}
            <Route path="/payment-success/:paymentId" element={<PaymentSuccess />} />
            <Route path="/payment-failed" element={<PaymentFailed />} />
            <Route path="/payment-callback" element={<PaymentCallback />} />

            {/* Guardian Retention Response - Public route without layout */}
            <Route path="/guardian/retention/:token/:response" element={<GuardianRetentionResponse />} />

            {/* Protected routes with layout */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/dashboard" element={<Dashboard />} />
              <Route path="/marketing" element={<MarketingDashboard />} />
              <Route path="/guardian-manager-dashboard" element={<GuardianManagerDashboard />} />
              {/* Reports */}
              <Route path="/reports" element={<Reports />} />
              {/* Audit Log */}
              <Route path="/audit" element={<AuditLog />} />
              {/* Services */}
              <Route path="/services" element={<Services />} />
              <Route
                path="/guardian-dashboard"
                element={<GuardianDashboard />}
              />
              <Route
                path="/guardian-dashboard/recommend-friend-thanks"
                element={<RecommendFriendThanks />}
              />
              <Route
                path="/guardian-edit-profile"
                element={<GuardianEditProfile />}
              />
              <Route
                path="/guardian-edit-profile/:guardianId"
                element={<GuardianEditProfile />}
              />
              <Route
                path="/guardians/empty-property-tip"
                element={<EmptyPropertyTip />}
              />
              <Route path="/guardian-viewings" element={<GuardianViewings />} />
              {/* Guardian Placement - Unified Component (legacy) */}
              <Route path="/guardian-placement/:propertyId/:guardianId" element={<GuardianPlacement />} />
              {/* Sales with Guardians Dashboard */}
              <Route path="/sales-with-guardians-dashboard" element={<SalesWithGuardiansDashboard />} />
              {/* Users */}
              <Route path="/users" element={<Users />} />
              <Route path="/users/create" element={<UserCreate />} />
              <Route path="/users/:id" element={<UserShow />} />
              <Route path="/users/:id/edit" element={<UserEdit />} />
              <Route path="/users/:id/calendar" element={<UserCalendar />} />
              <Route path="/my-email-preferences/edit" element={<UserEmailPreferences />} />
              {/* Clients */}
              <Route path="/clients" element={<Clients />} />
              <Route path="/clients/create" element={<ClientCreate />} />
              <Route path="/clients/:id" element={<ClientShow />} />
              <Route path="/clients/:id/edit" element={<ClientEdit />} />
              {/* Client Contacts */}
              <Route path="/clients/contacts" element={<ClientsContacts />} />
              {/* Client Emails - specific routes first */}
              <Route path="/clients/emails/status/create" element={<ClientsEmailStatusCreate />} />
              <Route path="/clients/emails/status/:statusId" element={<ClientsEmailAll />} />
              <Route path="/clients/emails" element={<ClientsEmailAll />} />
              {/* Client Documents */}
              <Route path="/clients/:id/documents/create" element={<ClientDocumentCreate />} />
              <Route path="/clients/documents/:documentId/edit" element={<ClientDocumentEdit />} />
              {/* VIP Dashboard */}
              <Route path="/vip/client/:id" element={<VipClientDashboard />} />
              {/* Blocks */}
              <Route path="/blocks/create" element={<BlockCreate />} />
              <Route path="/blocks/:id/emails/guardians/create" element={<BlockEmailGuardiansCreate />} />
              <Route path="/blocks/:id" element={<BlockShow />} />
              <Route path="/blocks/:id/edit" element={<BlockEdit />} />
              {/* Monthly Inspection Reports (Client-specific) */}
              <Route
                path="/monthly_inspections/:clientId/:reportId"
                element={<MonthlyInspectionReportView />}
              />
              {/* Certificates */}
              <Route path="/clients/certificates" element={<Certificates />} />
              <Route path="/certificates/review-queue" element={<CertificateReviewQueue />} />
              <Route
                path="/clients/:propertyId/certificates/:documentId/edit"
                element={<CertificateEdit />}
              />
              {/* Staff */}
              <Route path="/staff" element={<Staff />} />
              {/* Departments */}
              <Route path="/departments" element={<Departments />} />
              <Route
                path="/departments/create"
                element={<DepartmentCreate />}
              />
              <Route path="/departments/:id" element={<DepartmentShow />} />
              <Route
                path="/departments/:id/edit"
                element={<DepartmentEdit />}
              />
              {/* Tickets */}
              <Route path="/tickets" element={<Tickets />} />
              <Route path="/client-tickets" element={<ClientTickets />} />
              <Route path="/clients/:id/tickets" element={<ClientTickets />} />
              <Route path="/clients/:id/tickets/cost-of-works" element={<CostOfWorks />} />
              <Route path="/tickets/create" element={<TicketCreate />} />
              {/* Ticket detail routes - wrapped with GuardianTicketGuard for ownership checks */}
              <Route 
                path="/tickets/:id" 
                element={
                  <GuardianTicketGuard>
                    <TicketShow />
                  </GuardianTicketGuard>
                } 
              />
              <Route 
                path="/tickets/:id/documents/create" 
                element={
                  <GuardianTicketGuard>
                    <TicketDocumentCreate />
                  </GuardianTicketGuard>
                } 
              />
              <Route 
                path="/tickets/:id/edit" 
                element={
                  <GuardianTicketGuard>
                    <TicketEdit />
                  </GuardianTicketGuard>
                } 
              />
              <Route
                path="/tickets/:id/note/create"
                element={
                  <GuardianTicketGuard>
                    <TicketNoteCreate />
                  </GuardianTicketGuard>
                }
              />
              <Route
                path="/tickets/:id/notes/:noteId/edit"
                element={
                  <GuardianTicketGuard>
                    <TicketNoteEdit />
                  </GuardianTicketGuard>
                }
              />
              <Route
                path="/tickets/:id/notes/add"
                element={
                  <GuardianTicketGuard>
                    <TicketNoteAdd />
                  </GuardianTicketGuard>
                }
              />
              <Route
                path="/tickets/:id/notes/:noteId"
                element={
                  <GuardianTicketGuard>
                    <TicketNoteView />
                  </GuardianTicketGuard>
                }
              />
              <Route path="/tickets/calendar" element={<TicketsCalendar />} />
              <Route
                path="/tickets/member/calendar"
                element={<TicketsMemberCalendar />}
              />
              <Route
                path="/tickets/member/:userId/calendar"
                element={<TicketsMemberCalendar />}
              />
              <Route
                path="/tickets/:id/calendar"
                element={<TicketsMemberCalendar />}
              />
              <Route
                path="/tickets/:id/documents/:documentId/edit"
                element={
                  <GuardianTicketGuard>
                    <TicketDocumentEdit />
                  </GuardianTicketGuard>
                }
              />
              {/* Properties */}
              <Route path="/properties" element={<PropertyList />} />
              <Route path="/properties/create" element={<PropertyCreate />} />
              <Route path="/properties/:id" element={<PropertyShow />} />
              <Route path="/properties/:id/edit" element={<PropertyEdit />} />
              <Route path="/propertyproposals/:proposalId/sign" element={<PropertyProposalSign />} />
              <Route
                path="/properties/:id/liabilities/edit"
                element={<PropertyLiabilityEdit />}
              />
              <Route
                path="/properties/:id/photos"
                element={<PropertyPhotos />}
              />
              <Route
                path="/properties/:id/emails/guardians/create"
                element={<PropertyEmailGuardiansCreate />}
              />
              <Route
                path="/properties/:id/documents/create"
                element={<PropertyDocumentCreate />}
              />
              <Route
                path="/properties/:id/certificate/create"
                element={<PropertyCertificateCreate />}
              />
              <Route path="/certificate-demo" element={<CertificateDemo />} />
              <Route
                path="/properties/:id/documents"
                element={<PropertyDocuments />}
              />
              <Route
                path="/properties/:propertyId/documents/:documentId/edit"
                element={<PropertyDocumentEdit />}
              />
              <Route
                path="/properties/:id/payments"
                element={<PropertyPayments />}
              />
              <Route
                path="/properties/:id/viewings"
                element={<PropertyViewings />}
              />
              <Route
                path="/properties/:id/monthly-inspections"
                element={<PropertyMonthlyInspections />}
              />
              <Route
                path="/properties/:id/expenditures"
                element={<PropertyExpenditures />}
              />
              <Route
                path="/properties/:id/reports/monthly_inspections/create"
                element={<MonthlyInspectionCreate />}
              />
              {/* Redirect route for old format: /monthly_inspections/{reportId}/edit/{period?} */}
              <Route
                path="/monthly_inspections/:reportId/edit/:period?"
                element={<MonthlyInspectionRedirect />}
              />
              <Route
                path="/properties/:propertyId/reports/monthly_inspections/:reportId/edit"
                element={<MonthlyInspectionEdit />}
              />
              <Route
                path="/properties/:propertyId/reports/property_proposals/create"
                element={<PropertyProposalCreate />}
              />
              <Route
                path="/properties/:propertyId/reports/property_proposals/:proposalId/edit"
                element={<PropertyProposalEdit />}
              />
              <Route
                path="/properties/:propertyId/reports/initial_inspections/create"
                element={<InitialInspectionCreate />}
              />
              <Route
                path="/properties/:propertyId/reports/initial_inspections/:reportId/edit"
                element={<InitialInspectionEdit />}
              />
              <Route
                path="/inspections/property/:id"
                element={<PropertyInspections />}
              />
              {/* Notice to Quit routes for properties */}
              <Route
                path="/properties/:id/notice-to-quit/create"
                element={<NoticeToQuitCreate />}
              />
              {/* Route without noticeId (matches Laravel) - fetches latest NTQ - MUST be before route with noticeId */}
              <Route
                path="/properties/:id/notice-to-quit/edit"
                element={<NoticeToQuitEdit />}
              />
              {/* Route with noticeId (for direct access) */}
              <Route
                path="/properties/:id/notice-to-quit/:noticeId/edit"
                element={<NoticeToQuitEdit />}
              />
              <Route
                path="/properties/:id/notice-to-quit/guardian-letters"
                element={<PropertyNoticeToQuitGuardianLetters />}
              />
              {/* Monthly inspection workflow route */}
              <Route
                path="/monthly-inspections/create/:id/:step"
                element={<MonthlyInspectionCreate />}
              />
              <Route path="/spaces/show/:id" element={<SpaceShow />} />
             

              <Route
                path="/spaces/keep-me-inform"
                element={<SpaceKeepMeInformed />}
              />
              <Route
                path="/spaces/keep-me-inform/:propertyId"
                element={<SpaceKeepMeInformed />}
              />
              <Route
                path="/properties/vacant-rooms"
                element={<VacantRooms />}
              />
              {/* Property Viewings */}
              <Route
                path="/property_viewings"
                element={<PropertyViewingsIndex />}
              />
              <Route
                path="/property_viewings/create"
                element={<PropertyViewingsCreate />}
              />
              <Route
                path="/property_viewings/property/:id"
                element={<PropertyViewings />}
              />
              <Route
                path="/property_viewings/user/:id"
                element={<PropertyViewingsUserCalendar />}
              />
              <Route
                path="/property_viewings/:id/edit"
                element={<PropertyViewingsEdit />}
              />
              <Route
                path="/property_viewings/:id/view-details"
                element={<PropertyViewingsViewDetails />}
              />
              <Route
                path="/property_viewings/:id/attend"
                element={<PropertyViewingsAttend />}
              />
              <Route
                path="/property_viewings/copy/:id/:period"
                element={<PropertyViewingsCopy />}
              />
              <Route
                path="/property_viewings/report"
                element={<PropertyViewingsReport />}
              />
              <Route
                path="/property_viewings/keep-informed/:propertyId"
                element={<PropertyViewingsKeepInformed />}
              />
              <Route path="/payments" element={<PaymentsIndex />} />
              <Route
                path="/properties/notice-to-quit"
                element={<PropertyNoticeToQuitIndex />}
              />
              <Route
                path="/properties/rooms-search"
                element={<PropertiesRoomsSearch />}
              />
              <Route path="/spaces/available" element={<SpacesAvailable />} />
              <Route path="/building-set-ups" element={<BuildingSetUps />} />
              <Route path="/inspections" element={<Inspections />} />
              <Route
                path="/inspections/create"
                element={<InspectionsCreate />}
              />
              <Route
                path="/inspections/:id/edit"
                element={<InspectionEdit />}
              />
              <Route
                path="/inspections/building-manager/:buildingManagerId"
                element={<BuildingManagerCalendar />}
              />
              <Route
                path="/inspections/building-manager/:buildingManagerId/email-reminder/create"
                element={<EmailReminderCreate />}
              />
              <Route path="/inspection-types" element={<InspectionTypes />} />
              <Route
                path="/inspection-types/create"
                element={<InspectionTypeCreate />}
              />
              <Route
                path="/inspection-types/:id/edit"
                element={<InspectionTypeEdit />}
              />
              <Route
                path="/properties/monthly-inspections"
                element={<PropertiesMonthlyInspections />}
              />
              <Route path="/inspection-routes" element={<InspectionRoutes />} />
              <Route
                path="/inspection-routes/:id/edit"
                element={<InspectionRouteEdit />}
              />
              <Route
                path="/inspection-routes/create"
                element={<InspectionRouteCreate />}
              />
              <Route
                path="/inspection-routes/:id"
                element={<InspectionRouteShow />}
              />
              <Route
                path="/payments/without-due-date"
                element={<PaymentsWithoutDueDate />}
              />
              <Route
                path="/finance/expense-account"
                element={<ExpenseAccount />}
              />
              <Route
                path="/finances/expense-account"
                element={<ExpenseAccount />}
              />
              <Route
                path="/finance/expense-account/create"
                element={<ExpenseAccountCreate />}
              />
              <Route
                path="/finances/expense-account/create"
                element={<ExpenseAccountCreate />}
              />
              <Route
                path="/finance/expense-account/:id/edit"
                element={<ExpenseAccountEdit />}
              />
              <Route
                path="/finances/expense-account/:id/edit"
                element={<ExpenseAccountEdit />}
              />
              <Route
                path="/finance/expense-account/:id/pay"
                element={<ExpenseAccountPay />}
              />
              <Route
                path="/finances/expense-account/:id/pay"
                element={<ExpenseAccountPay />}
              />
              <Route path="/expenditures" element={<Expenditures />} />
              <Route
                path="/expenditures/create"
                element={<ExpendituresCreate />}
              />
              <Route
                path="/expenditures/categories"
                element={<ExpendituresCategories />}
              />
              <Route path="/expenditures/:id" element={<ExpenditureShow />} />
              <Route
                path="/expenditures/:id/edit"
                element={<ExpenditureItemEdit />}
              />
              <Route
                path="/properties/:propertyId/expenditures"
                element={<PropertyExpenditures />}
              />
              <Route
                path="/properties/:propertyId/expenditures/items/:expenditureId/edit"
                element={<ExpenditureItemEdit />}
              />
              {/* Bank Accounts */}
              <Route path="/bank-accounts" element={<BankAccounts />} />
              <Route
                path="/bank-accounts/create"
                element={<BankAccountCreate />}
              />
              <Route
                path="/bank-accounts/:id/edit"
                element={<BankAccountEdit />}
              />
              <Route path="/petty-cash" element={<PettyCash />} />
              <Route path="/petty-cash/create" element={<PettyCashCreate />} />
              <Route path="/petty-cash/:id/edit" element={<PettyCashEdit />} />
              <Route
                path="/rents/:rentId/payments/:paymentId/edit"
                element={<PaymentEdit />}
              />
              <Route
                path="/rents/:rentId/payments/:paymentId/edit-initial"
                element={<PaymentEdit isInitialPayment={true} />}
              />
              <Route
                path="/payments/:paymentId/edit"
                element={<PaymentEdit />}
              />
              {/* Mark as Paid Payment Route */}
              <Route
                path="/rents/:rentId/payments/:paymentId/mark-as-paid"
                element={<MarkAsPaidPayment />}
              />

              {/* {<PropertyViewingsUserCalendar />} */}

              {/* Guardians */}
              <Route path="/guardians" element={<Guardians />} />
              {/* <Route path="/guardians/create" element={<GuardianCreate />} /> */}
              <Route
                path="/guardians/create"
                element={<GuardianCreateLaravel />}
              />
              <Route
                path="/guardians/:guardianId/payments"
                element={<GuardianPayments />}
              />
              <Route
                path="/rents/:rentId/payments/:paymentId/edit"
                element={<PaymentEdit />}
              />
              <Route
                path="/rents/:rentId/payments/create"
                element={<PaymentCreate />}
              />
              <Route path="/guardians/:id" element={<GuardianShow />} />
              <Route
                path="/guardians/:id/edit"
                element={<GuardianEditLaravel />}
              />
              <Route
                path="/guardians/documents/:id"
                element={<GuardianDocumentsManage />}
              />
              <Route
                path="/property-application/decline-documentation/:guardianId"
                element={<PropertyApplicationDeclineDocumentation />}
              />
              <Route
                path="/guardians/after-deadline"
                element={<GuardiansAfterDeadline />}
              />
              <Route
                path="/guardians/emails/status/create"
                element={<GuardianEmailStatusCreate />}
              />
              <Route
                path="/rents/:rentId/notice-to-quit/create"
                element={<NoticeToQuitCreate />}
              />
              {/* Route without noticeId (matches Laravel) - fetches latest NTQ - MUST be before route with noticeId */}
              <Route
                path="/rents/:rentId/notice-to-quit/edit"
                element={<NoticeToQuitEdit />}
              />
              {/* Route with noticeId (for direct access) */}
              <Route
                path="/rents/:rentId/notice-to-quit/:noticeId/edit"
                element={<NoticeToQuitEdit />}
              />
              <Route
                path="/rents/notice-to-quit/create"
                element={<NoticeToQuitCreate />}
              />
              <Route
                path="/test-notice-to-quit"
                element={<NoticeToQuitCreate />}
              />
              <Route
                path="/role-hierarchy-test"
                element={<RoleHierarchyTest />}
              />
              {/* Rents */}
              {/* Laravel route: /rents/{room}/payments/edit - Change Rent screen */}
              {/* Route structure: /rents/:roomId/payments/edit (matches backend) */}
              <Route
                path="/rents/:roomId/payments/edit"
                element={<RentPaymentsEdit />}
              />
              {/* Backward compatibility: /rents/payments/edit/:roomId (old format) */}
              <Route
                path="/rents/payments/edit/:roomId"
                element={<RentPaymentsEdit />}
              />
              <Route
                path="/rents/payments/edit"
                element={<RentPaymentsEdit />}
              />
              {/* Support rentId in URL: /rents/payments/edit/:rentId */}
              <Route
                path="/rents/payments/edit/:rentId"
                element={<RentChangeRent />}
              />
              <Route path="/rents/:rentId/resale" element={<RentResale />} />
              <Route
                path="/rents/:rentId/dates/edit"
                element={<RentDatesEdit />}
              />
              <Route path="/rents" element={<Rents />} />
              <Route
                path="/rents/:rentId/officer/edit"
                element={<RentGuardianOfficerEdit />}
              />
              {/* Backward compatibility - redirect old route to new route */}
              <Route
                path="/rents/:rentId/change-rent"
                element={<RentChangeRent />}
              />
              <Route
                path="/rents/:rentId/payments"
                element={<RentPayments />}
              />
              <Route
                path="/rents/:rentId/licences/edit"
                element={<RentLicencesEdit />}
              />
              {/* Employment History */}
              <Route
                path="/employment-history/:id/edit"
                element={<EmploymentHistoryEdit />}
              />
              <Route path="/rooms/:id/show" element={<RoomShow />} />
              <Route path="/rooms/:roomId/manage" element={<RoomManage />} />
              <Route path="/rooms/assign/:guardianId" element={<RoomAssign />} />
              <Route path="/guardian-placement/step1/:propertyId/:guardianId" element={<GuardianPlacementStep1 />} />
              <Route path="/guardian-placement/step1b/:propertyId/:guardianId/:roomId" element={<GuardianPlacementStep1B />} />
              <Route path="/guardian-placement/step2/:propertyId/:guardianId/:roomId" element={<GuardianPlacementStep2 />} />
              <Route path="/guardian-placement/step2/:propertyId/:guardianId/:roomId/:secondGuardianId" element={<GuardianPlacementStep2 />} />
              <Route path="/guardian-placement/step3/:propertyId/:guardianId/:roomId" element={<GuardianPlacementStep3 />} />
              <Route path="/guardian-placement/step3/:propertyId/:guardianId/:roomId/:secondGuardianId" element={<GuardianPlacementStep3 />} />
              {/* Laravel route: /property-application/set-payment/{room} */}
              <Route path="/property-application/set-payment/:roomId" element={<SetPayment />} />
              {/* Backward compatibility: Keep old route */}
              <Route path="/property-application/payment/create/:roomId" element={<SetPayment />} />
              {/* Laravel route: /rents/{rentId}/payments/mark-as-paid-initial/{paymentId} */}
              <Route path="/rents/:rentId/payments/mark-as-paid-initial/:paymentId" element={<MarkAsPaid />} />
              {/* Backward compatibility: Keep old route */}
              <Route path="/payments/mark-as-paid-initial/:rentId/:paymentId?" element={<MarkAsPaid />} />
              <Route path="/property-application/sign-agreement/:rentId" element={<SignAgreement />} />
              <Route path="/rents/:rentId/start" element={<StartRent />} />
              {/* <Route path="/rooms" element={<RoomsCouples />} /> */}

              <Route
                path="/rents/after-date-end"
                element={<RentsAfterDateEnd />}
              />
              <Route
                path="/rents/notice_to_quit"
                element={<RentsNoticeToQuit />}
              />
              <Route
                path="/rents/:rentId/notice-to-quit/uploadFile"
                element={<RentsNoticeToQuitUploadFile />}
              />

              <Route
                path="/client-knowledge/life-enhancing-chances"
                element={<LifeEnhancingChances />}
              />

              <Route path="/rooms/couples" element={<RoomsCouples />} />
              {/* Hear About */}
              <Route path="/hear_about" element={<HearAbout />} />
              {/* Lead Sources */}
              <Route path="/lead-sources" element={<LeadSources />} />
              <Route
                path="/lead-sources/create"
                element={<LeadSourceCreate />}
              />
              <Route
                path="/lead-sources/:id/edit"
                element={<LeadSourceEdit />}
              />
              {/* Website Leads */}
              <Route path="/website-leads" element={<WebsiteLeads />} />
              {/* Market Segments */}
              <Route path="/market-segments" element={<MarketSegments />} />
              <Route
                path="/market-segments/create"
                element={<MarketSegmentCreate />}
              />
              <Route
                path="/market-segments/:id/edit"
                element={<MarketSegmentEdit />}
              />
              {/* Quality */}
              <Route
                path="/quality/guardians/placed"
                element={<QualityGuardiansPlaced />}
              />
              <Route
                path="/guardians/registered"
                element={<QualityGuardiansRegistered />}
              />
              <Route
                path="/quality/guardians/forecasting"
                element={<QualityGuardiansForecasting />}
              />
              {/* BDM */}
              <Route path="/bdm" element={<BdmDashboard />} />
              {/* Settings */}
              <Route path="/settings" element={<Settings />} />
              <Route path="/settings/email" element={<SettingsEmail />} />
              {/* Roles and Permissions */}
              <Route path="/roles" element={<Roles />} />
              <Route path="/roles/:id/edit" element={<RoleEdit />} />
              <Route path="/permissions" element={<CrmPermissions />} />
              <Route path="/permissions/create" element={<CrmPermissionCreate />} />
              <Route
                path="/permissions/:id/edit"
                element={<CrmPermissionEdit />}
              />
              <Route
                path="/permissions/category/:id/users"
                element={<CrmPermissionCategoryUsers />}
              />
              <Route path="/permissions/:id" element={<CrmPermissionView />} />
              <Route
                path="/roles_permissions"
                element={<CrmRolesPermissions />}
              />
              {/* Complaints */}
              <Route path="/complaints" element={<Complaints />} />
              {/* Guardian Queries */}
              <Route path="/guardian-queries" element={<GuardianQueries />} />
              <Route
                path="/guardian-queries/:id"
                element={<GuardianQueryDetail />}
              />
              {/* Contractors */}
              <Route path="/contractors" element={<Contractors />} />
              <Route
                path="/contractors/create"
                element={<ContractorCreate />}
              />
              <Route path="/contractors/:id" element={<ContractorShow />} />
              <Route
                path="/contractors/:id/edit"
                element={<ContractorEdit />}
              />
              <Route
                path="/contractors/:id/documents/create"
                element={<ContractorDocumentCreate />}
              />
               <Route
                path="/contractors/:id/documents/:documentId/edit"
                element={<ContractorDocumentEdit />}
              />
              <Route
                path="/contractors/contacts"
                element={<ContractorContacts />}
              />
              <Route
                path="/contractors/contacts/:id/calendar"
                element={<ContractorContactCalendar />}
              />
              <Route
                path="/guardian-queries/create"
                element={<GuardianQueryCreate />}
              />
              <Route
                path="/guardian-queries/:id"
                element={<GuardianQueryDetail />}
              />
              <Route path="/guardian-payments" element={<GuardianPayments />} />
              <Route path="/pli-dashboard" element={<PliDashboard />} />
              <Route path="/pli-review-queue" element={<PliReviewQueue />} />
              {/* P2P v1 — supplier bills in Xero not yet recorded in MyGlobe */}
              <Route path="/xero-bills" element={<XeroBillsQueue />} />
              <Route path="/xero-bills/:xeroInvoiceId" element={<XeroBillRecord />} />
              <Route
                path="/guardian-email-preferences"
                element={<GuardianEmailPreferences />}
              />
              <Route
                path="/guardian-property-search"
                element={<GuardianPropertySearch />}
              />
              <Route
                path="/guardian-property-details/:propertyId"
                element={<GuardianPropertyDetails />}
              />
              <Route path="/keep-me-informed" element={<KeepMeInformed />} />
              <Route
                path="/guardians/license-agreement"
                element={<LicenseAgreement />}
              />
              <Route
                path="/useful-information"
                element={<UsefulInformation />}
              />
              {/* Cost of Works */}
              <Route path="/cost-of-works" element={<CostOfWorks />} />
              <Route
                path="/cost-of-works/reports"
                element={<CostOfWorksReports />}
              />
              <Route
                path="/client-knowledge/property-guardian-solution"
                element={<PropertyGuardianSolution />}
              />
              <Route
                path="/client-knowledge/luxury-house-sitting"
                element={<LuxuryHouseSitting />}
              />
              <Route
                path="/client-knowledge/safety-management"
                element={<SafetyManagement />}
              />
              <Route
                path="/client-knowledge/building-management"
                element={<BuildingManagement />}
              />
              <Route
                path="/client-knowledge/improve-your-void"
                element={<ImproveYourVoid />}
              />
              <Route
                path="/client-knowledge/property-guardian-insurance"
                element={<PropertyGuardianInsurance />}
              />
              <Route
                path="/client-knowledge/void-into-profit"
                element={<VoidIntoProfit />}
              />
              <Route
                path="/client-knowledge/proptech-software-solutions"
                element={<ProptechSoftwareSolutions />}
              />
              <Route
                path="/properties/:propertyId/certificate/:documentId/edit"
                element={<CertificateEdit />}
              />
            </Route>

            {/* 404 Not Found route */}
            <Route
              path="*"
              element={
                <div style={{ padding: 40, textAlign: 'center' }}>
                  <h2>404 - Page Not Found</h2>
                </div>
              }
            />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App;
